const buildFilterableModelRequestParams = (data ?:{
  params ?:Record<string, string | number | string[]>;
  filters ?:{ column :string; operator :string; value :string | number }[];
}) :Record<string, string | string[]> => {
  const { params = {}, filters = [] } = data || {};

  const defaultParams = {
    page: '1',
    limit: '50',
    sortField: 'id',
    sortDirection: 'desc',
  };

  const filterParams :Record<string, string | string[]> = {};
  const updatedFilters :string[] = [];

  filters.forEach(({ column, operator, value }) => {
    updatedFilters.push(`${column}|${operator}|${value}`);
  });

  if (updatedFilters.length > 0) {
    filterParams['filters[]'] = updatedFilters;
  }

  return {
    ...defaultParams,
    ...filterParams,
    ...params,
  };
};

const extendRequestParams = (
  baseParams :Record<string, string | string[]>,
  data ?:{
    params ?:Record<string, string | number | string[]>;
    filters ?:{ column :string; operator :string; value :string | number }[];
  },
) :Record<string, string | string[]> => {
  const { params = {}, filters = [] } = data || {};
  const updatedFilters = [...(baseParams['filters[]'] || [])];

  filters.forEach(({ column, operator, value }) => {
    updatedFilters.push(`${column}|${operator}|${value}`);
  });

  return {
    ...baseParams,
    ...(updatedFilters.length > 0 ? { ['filters[]']: updatedFilters } : {}),
    ...params,
  };
};

export const QueryBuilderUtils = {
  buildFilterableModelRequestParams,
  extendRequestParams,
};
